/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useContext, useState } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import {
  StyledHeroBannerCarousel,
  GlobalStyle,
  ShowMiniCards,
  StyledOverlayContainer,
  StyledCityPageHeroBanner,
  StyledCampaignHeroBanner,
} from './AwpHeroBanner.styles';
import { Image, Text, Icon, Types, Heading } from '@marriott/mi-ui-library';
import { MLogoContainer } from '@marriott/mi-web-ui-kit';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { PageParamsContext } from '../../modules/context/PageContext';
import { outletDetailsState, useStore } from '../../modules/store/outletDetailsStore';
import OutletDetailsMock from './__mocks__/OutletDetailsMock.json';
import { awpErrorState, awpErrorStore } from '../../modules/store/awpErrorStore';
import { AwpHeroImageCarousel } from '../AwpHeroImageCarousel';
import clsx from 'clsx';
import { mockHeroBannerImage } from './__mocks__/mockModel';
import { useGetBreakpoint } from '../../modules/utils/helpers';
import { campaignDetailsStore } from '../../modules/store/campaignDetailsStore';
import {
  campaignPage,
  cityPage,
  earnRedeemPage,
  golfOverviewPage,
  golfBusinessCoursesPage,
  IMAGE_URL_DOMAIN,
  travelerTopicHubPage,
} from '../../modules/utils/constants';
import campaignOffersDetailsMock from '../../organisms/CampaignOffersCardContainer/__mocks__/CampaignOfferDetailsMock.json';

const { tags, size } = Types;
const { NEXT_PUBLIC_AEM_SITE } = process.env;

export const AwpHeroBanner = (props: any) => {
  const setErrorState = awpErrorStore((state: awpErrorState) => state.setErrorState);
  const {
    fallbackDescription,
    fallbackHeroImgPath,
    outletDataResponse,
    heroBannerImages,
    campaignId,
    campaignDataResponse,
    campaignDataError,
  } = useContext(PageParamsContext);
  const outletDataError = useStore((state: outletDetailsState) => state.outletDataError);
  const setData = useStore((state: outletDetailsState) => state.setData);
  const outletData = useStore((state: outletDetailsState) => state.outletData);
  const [isMobileViewPort, setIsMobileViewPort] = useState(useGetBreakpoint() === 'mobile');
  const [isDesktopViewPort, setIsDesktopViewPort] = useState(useGetBreakpoint() === 'desktop');
  const campaignData = campaignDetailsStore(state => state.campaignData);
  const setCampaignId = campaignDetailsStore(state => state.setCampaignId);
  const setCampaignData = campaignDetailsStore(state => state.setCampaignData);
  const setCampaignDataError = campaignDetailsStore(state => state.setCampaignDataError);
  const setCampaignOffersList = campaignDetailsStore(state => state.setCampaignOffersList);

  const isCampaignUXLdata: boolean =
    props?.pageType === campaignPage &&
    !!campaignData?.heroBanner?.imageUrls?.square &&
    !!campaignData?.heroBanner?.imageUrls?.panoramicHorizontal;

  useEffect(() => {
    if (props?.isAuthorMode) {
      setData(
        OutletDetailsMock?.data?.restaurantById,
        false,
        false,
        { fallbackDescription, fallbackHeroImgPath },
        mockHeroBannerImage
      );
    } else if (!outletDataResponse) {
      setData(null, false, true, {}, []);
    } else if (outletDataResponse && !outletData) {
      setData(outletDataResponse, false, false, { fallbackDescription, fallbackHeroImgPath }, heroBannerImages);
    }
  }, [outletDataResponse, props?.isAuthorMode, setData, fallbackDescription, fallbackHeroImgPath]);

  useEffect(() => {
    if (outletDataError) {
      setErrorState(0, 'apiError');
    }
  }, [outletDataError, setErrorState]);

  useEffect(() => {
    if (props?.isAuthorMode) {
      setCampaignData(campaignOffersDetailsMock?.data?.diningOfferCampaignDetails);
      setCampaignDataError(false);
      setCampaignOffersList(campaignOffersDetailsMock?.data?.diningOfferCampaignDetails?.OfferDetail, false, false);
    } else {
      setCampaignId(campaignId);
      setCampaignData(campaignDataResponse);
      setCampaignDataError(campaignDataError || false);
    }
  }, [campaignId, campaignDataResponse, campaignDataError, props?.isAuthorMode]);

  useEffect(() => {
    function handleResize() {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      setIsMobileViewPort(useGetBreakpoint() === 'mobile');
      // eslint-disable-next-line react-hooks/rules-of-hooks
      setIsDesktopViewPort(useGetBreakpoint() === 'desktop');
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (props?.pageType === cityPage || props?.pageType === golfOverviewPage) {
    return (
      <StyledCityPageHeroBanner pageType={props?.pageType} className={clsx(props?.styleclass, 'city-page-hero-banner')}>
        <Image
          title=""
          defaultImageURL={props?.dynamicMedia?.assetPath}
          customClass=""
          loading="eager"
          altText={props?.dynamicMedia?.altText}
          renditions={props?.dynamicMedia?.renditions}
          dynamic={props?.dynamic}
        />
        {props?.overlayText && (
          <div data-testid="overlayTextTest" className="bl_iconText-wrapper">
            <div className={`t-label-inverse-xs`}>
              <Icon iconClass={props?.iconPath} ariaLabel="aria-label" />
              <Text
                fontSize={size.extraSmall}
                copyText={props?.overlayText}
                element={tags.span}
                customClass="px-1"
              ></Text>
            </div>
          </div>
        )}
      </StyledCityPageHeroBanner>
    );
  } else if (
    props?.pageType === campaignPage ||
    props?.pageType === earnRedeemPage ||
    props?.pageType === golfBusinessCoursesPage ||
    props?.pageType === travelerTopicHubPage
  ) {
    return (
      <StyledCampaignHeroBanner styleClass={props?.styleclass} className={props?.styleclass}>
        <div className="bl-item">
          <Image
            title=""
            defaultImageURL={
              isCampaignUXLdata
                ? isMobileViewPort
                  ? `${IMAGE_URL_DOMAIN}${campaignData?.heroBanner?.imageUrls?.square}`
                  : `${IMAGE_URL_DOMAIN}${campaignData?.heroBanner?.imageUrls?.panoramicHorizontal}`
                : props?.dynamicMedia?.assetPath
            }
            loading="eager"
            altText={
              props?.pageType === campaignPage && campaignData?.heroBanner?.alternateDescription
                ? campaignData?.heroBanner?.alternateDescription
                : props?.dynamicMedia?.altText
            }
            renditions={isCampaignUXLdata ? null : props?.dynamicMedia?.renditions}
            dynamic={isCampaignUXLdata ? null : props?.dynamic}
          />
        </div>
        {(props?.pageType === earnRedeemPage || props?.pageType === golfBusinessCoursesPage) && props?.overlayText && (
          <div data-testid="overlayTextTest" className="bl_iconText-wrapper">
            <div className={`t-label-inverse-xs`}>
              <Icon iconClass={props?.iconPath} ariaLabel="aria-label" />
              <Text
                fontSize={size.extraSmall}
                copyText={
                  props?.pageType === earnRedeemPage || props?.pageType === golfBusinessCoursesPage
                    ? props?.overlayText
                    : ''
                }
                element={tags.span}
                customClass="px-1"
              ></Text>
            </div>
          </div>
        )}
        {(campaignData?.title || props?.header) && (
          <div className={`bl__cnt-sec gradient`}>
            <div className="container-sm bl__cnt-ctr px-3 px-md-0">
              <div className="row m-0">
                <div
                  className={clsx(
                    'p-sm-0 p-md-0 p-lg-0 p-xl-0 col-12',
                    props?.pageType === travelerTopicHubPage ? 'col-md-8 col-lg-6' : 'col-md-6 col-lg-5 col-xl-5'
                  )}
                >
                  {props?.brand && props?.pageType === travelerTopicHubPage && (
                    <MLogoContainer
                      brand={props?.brand}
                      aspectRatio={props?.aspectRatio}
                      width={135}
                      height={110}
                      isLink={false}
                      ariaRole="img"
                      alignment={'Bottom Left'}
                      backgroundColor="mb-3 mb-md-4"
                      color={'background-aware'}
                    />
                  )}
                  {(campaignData?.title || props?.header) && (
                    <Heading
                      titleText={
                        props?.pageType === earnRedeemPage ||
                        props?.pageType === golfBusinessCoursesPage ||
                        props?.pageType === travelerTopicHubPage
                          ? props?.header
                          : campaignData?.title
                          ? campaignData?.title
                          : ''
                      }
                      variation={Types.headingType.title}
                      fontSize={Types.size.medium}
                      customClass={clsx('mb-2 t-title-m campaign-title banner-header')}
                    />
                  )}
                  {(campaignData?.description || props?.description) && (
                    <Text
                      fontSize={isMobileViewPort ? size.small : size.medium}
                      copyText={
                        props?.pageType === earnRedeemPage || props?.pageType === travelerTopicHubPage
                          ? props?.description
                          : campaignData?.description
                          ? campaignData?.description
                          : ''
                      }
                      element={tags.span}
                      customClass={clsx(
                        isMobileViewPort ? 't-font-s' : 't-font-m',
                        props?.pageType === travelerTopicHubPage
                          ? isDesktopViewPort
                            ? 'm-ellipsis-4lines'
                            : 'm-ellipsis-3lines'
                          : ''
                      )}
                    ></Text>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </StyledCampaignHeroBanner>
    );
  } else {
    return outletDataError === true ? null : outletData &&
      outletDataError === false &&
      (props?.heroBannerCarouselDisabled || outletData?.heroBannerImages?.length === 1) ? (
      <StyledHeroBannerCarousel className={clsx('outlet-hero-banner outlet-page-hero-banner', props?.styleclass)}>
        <GlobalStyle />
        <ShowMiniCards />
        <StyledOverlayContainer iconPath={!!props?.iconPath}>
          <Image
            title=""
            defaultImageURL={
              outletData?.heroBannerImages[0]?.isFallBackImage
                ? outletData?.heroBannerImages[0]?.dynamicMedia?.assetPath
                : outletData?.heroBannerImages[0]?.defaultImageUrl
            }
            customClass="outlet-hero-banner--img"
            loading="eager"
            altText={
              outletData?.heroBannerImages[0]?.isFallBackImage
                ? outletData?.heroBannerImages[0]?.dynamicMedia?.altText
                : 'Slide-1'
            }
            renditions={
              outletData?.heroBannerImages[0]?.isFallBackImage
                ? outletData?.heroBannerImages[0]?.dynamicMedia?.renditions
                : null
            }
            dynamic={outletData?.heroBannerImages[0]?.isFallBackImage ? true : false}
          />
          {outletData?.heroBannerImages[0]?.isFallBackImage && (
            <div className="overlay-content d-flex justify-content-center align-items-center flex-column">
              {!!props.iconPath && (
                <span className={clsx('icon-inverse mb-4 d-inline-flex', `${props.iconPath}`)}></span>
              )}
              {!!props.overlayText && <div className="t-subtitle-inverse-l">{props?.overlayText}</div>}
            </div>
          )}
        </StyledOverlayContainer>
      </StyledHeroBannerCarousel>
    ) : outletData &&
      outletDataError === false &&
      (!props?.heroBannerCarouselDisabled || outletData?.heroBannerImages?.length > 1) ? (
      <StyledHeroBannerCarousel className={clsx('outlet-hero-banner outlet-page-hero-banner', props?.styleclass)}>
        <GlobalStyle />
        <ShowMiniCards />
        <AwpHeroImageCarousel images={outletData?.heroBannerImages} imgCustomClass="outlet-hero-banner--img" />
      </StyledHeroBannerCarousel>
    ) : (
      <div className="spinner-wrapper d-flex justify-content-center align-items-center vh-100">
        <GlobalStyle />
        <div className="m-spinner-m"></div>
      </div>
    );
  }
};

export const AwpHeroBannerConfig = {
  emptyLabel: 'OutletHeroBanner',
  isEmpty: false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/content/herobannercarousel`,
};

export const AwpHeroBannerEditable = (props: any) => (
  <div data-component-name="m-awp-AwpHeroBanner" data-testid="awp-AwpHeroBanner">
    <EditableComponent config={AwpHeroBannerConfig} {...props}>
      <AwpHeroBanner {...props} />
    </EditableComponent>
  </div>
);
